export const geoserver_layers = [
    {
        id:"nCount:Himachal_aesculus_indica",
        sci_name:"Aesculusi indica",
        local_name:"Khanor"
    },
    {
        id:"nCount:Himachal_bambusoideae_spp",
        sci_name:"Bambusa bamboo",
        local_name:"Maggar"
    },
    {
        id:"nCount:Individual_berberis_aristate",
        sci_name:"Berberis aristate",
        local_name:"Kashmal"
    },
    {
        id:"nCount:Himachal_Pinus_roxburghii",
        sci_name:"Chir pine",
        local_name:"Chir"
    },
    {
        id:"nCount:Himachal_Dendrocalamus_strictus",
        sci_name:"Dendrocalamus strictus",
        local_name:"Bans"
    },
    {
        id:"nCount:Himachal_Eucalyptus_globulus",
        sci_name:"Eucalyptus",
        local_name:"Safeda"
    },
    {
        id:"nCount:Himachal_Phyllanthus_emblica",
        sci_name:"Indian gooseberry",
        local_name:"Amla"
    },
    {
        id:"nCount:Himachal_Lantana_camara",
        sci_name:"Lantana",
        local_name:"Fulnu"
    },
    {
        id:"nCount:Himachal_Quercus_leucotrichophora",
        sci_name:"Quercus leucotrichophora",
        local_name:"Ban Oak"
    },
    {
        id:"nCount:Himachal_Rhododendron_arboreum",
        sci_name:"Rhododendron",
        local_name:"Buransh"
    },
    {
        id:"nCount:Himachal_Senegalia_catechu",
        sci_name:"Senegalia catechu",
        local_name:"Khair"
    },
    {
        id:"nCount:Himachal_Shorea_robusta",
        sci_name:"Shorea robusta",
        local_name:"Sal"
    },
    {
        id:"nCount:Himachal_Cedrus_deodara",
        sci_name:"Cedrus deodara",
        local_name:"Deodar"
    },
    {
        id:"nCount:Himachal_Taxus_baccata",
        sci_name:"Taxus baccata",
        local_name:"Rakhal"
    },
    {
        id:"nCount:Himachal_Mangifera_sylvatica",
        sci_name:"Wild mango",
        local_name:"Aam"
    },
]